import { cva, type VariantProps } from 'class-variance-authority'
import type { AnchorHTMLAttributes, ComponentProps } from 'react'
import { cn } from '../../lib/cn'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        primary: 'bg-primary text-primary-contrast hover:bg-primary-hover',
        accent: 'bg-accent text-accent-contrast hover:bg-accent-hover',
        secondary: 'border border-line bg-surface text-ink hover:bg-black/5',
        ghost: 'text-ink hover:bg-black/5',
        danger: 'border border-danger/30 bg-surface text-danger hover:bg-danger/5',
      },
      size: {
        md: 'px-5 py-2.5 text-sm',
        lg: 'px-6 py-3 text-base',
        sm: 'px-3 py-1.5 text-sm',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
)

/** A button's attributes, its ref included (a prop like any other since React 19). */
export type ButtonProps = ComponentProps<'button'> & VariantProps<typeof buttonVariants>

export function Button({ className, variant, size, type = 'button', ...props }: ButtonProps) {
  return (
    <button type={type} className={cn(buttonVariants({ variant, size }), className)} {...props} />
  )
}

export function ButtonLink({
  className,
  variant,
  size,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & VariantProps<typeof buttonVariants>) {
  return <a className={cn(buttonVariants({ variant, size }), className)} {...props} />
}
